import { isUAT } from "./debug";
import webapi from "./fetch";
import { GetReceiveCouponResp } from "optimus-front/lib/utils/zeusFetch";

/** 领取型优惠券 ReceiveCoupon  */
interface CouponsParams {
	client: "vela_pc" | "vela";
	isUat: string;
	language: string;
	currency: string;
	country: string;
	sid: string;
	sessionkey: string;
	campaign_key: string;
}

const API_UAT = "https://kdev0.tbox.me";
const API_ONLINE = "https://pro.lightinthebox.com";

const transformAddress = (isOnline: boolean, isMobile: boolean) => {
	return `${isOnline ? API_ONLINE : API_UAT}/litb-header-zeus/${isMobile ? "mweb" : "web"}`;
};

export function getCategories(params: CouponsParams, options): Promise<GetReceiveCouponResp> {
	return webapi<GetReceiveCouponResp>(
		"api/v1/rewardcredits/promotion/getCoupons",
		{ ...params },
		options,
	);
}

export const getGetCoupons = (
	params: CouponsParams,
	isMobile: boolean,
): Promise<GetReceiveCouponResp> => {
	const options = {
		fetchMethod: "GET",
		apiDomain: transformAddress(!isUAT(), isMobile),
	};
	return getCategories(params, options);
};
